<script>
import {QuoteProps} from './index.js'
import {HEADER_PARAMS_KEYS} from 'fe-coms-share/paas/constants'
import {COMPONENTS_NAMES} from 'fe-coms-share/paas/constants/componet-names'
import {FIELD_TYPE} from 'fe-coms-share/paas/constants'
import defaultValue from '../../../utils/default-value'

export default {
  name: 'quote',
  props: QuoteProps,
  inject: ['formData', 'row', 'subData', 'store'],
  mixins: [defaultValue],
  computed: {
    headerParams () {
      const {relateObjectApiName, layoutApiName} = this.relateField
      return {
        [HEADER_PARAMS_KEYS.tenantType]: this.tenantType,
        [HEADER_PARAMS_KEYS.layoutApiName]: layoutApiName,
        [HEADER_PARAMS_KEYS.objectApiName]: relateObjectApiName
      }
    },
    rowId () {
      return this.row?.['aPaaS_SequenceId']
    },
    relateNode () {
      return this.params.relateNode
    },
    relateNodeInPage () {
      const {objectApiName, apiName} = this.params.relateNode
      const fieldMap = this.store?.fieldMap && this.store.fieldMap() || {}
      return !!fieldMap?.[objectApiName]?.[apiName] || !!this.relateField
    },
    // 查询当前引用字段引用的查找关联字段
    relateField () {
      const fieldMap = this.store?.fieldMap && this.store.fieldMap() || {}
      // 引用的查找关联字段的apiName
      const {quoteNode: {relationFieldApiName}, objectApiName} = this.params
      return fieldMap?.[objectApiName]?.[relationFieldApiName]
    },
    /**
     * 1. 查找关联和引用字段在同一个对象
     * 2. 查找关联在主对象, 引用字段在从对象
     * @returns {{fieldApiName, objectApiName}}
     */
    parentParams () {
      const {relateObjectApiName, relateFieldApiName, quoteNode} = this.params
      let parentObjectApiName = this.relateField?.objectApiName
      let parentFieldApiName = this.relateField?.apiName
      let fieldType = this.relateField?.type
      if (relateObjectApiName && (quoteNode.objectApiName !== relateObjectApiName) && !this.relateField) {
        parentObjectApiName = relateObjectApiName
        parentFieldApiName = relateFieldApiName
        fieldType = ''
      }
      return {
        objectApiName: parentObjectApiName,
        fieldApiName: parentFieldApiName,
        fieldType
      }
    }
  },
  mounted () {
    // 详情页列表不需要初始化关系 详情列表的值已经返回引用字段的值数据
    if (this.params.resInterfaces && this.relateNodeInPage) {
      this.initRelate()
    }
  },
  methods: {
    initRelate () {
      /**
       * 1. 引用字段摘要区重复字段只触发一个字段
       * 2. 引用字段内不知道查找关联字段是从对象字段还是主对象字段 rowId要不要传
       */
      const {quoteNode, relateObjectApiName, relateFieldApiName} = this.params
      const rowId = quoteNode.objectApiName === this.relateField?.objectApiName && typeof this.rowIndex === 'number'
        ? this.rowId
        : null
      const parentNodeParams = {
        ...this.parentParams,
        relationFieldApiName: relateFieldApiName,
        relationFieldObjectApiName: relateObjectApiName,
        subObjectParamName: quoteNode.parentKey,
        field: this.relateField,
        rowId
      }

      this.createRelate(
        parentNodeParams,
        {
          objectApiName: quoteNode.objectApiName,
          fieldApiName: quoteNode.apiName,
          subObjectParamName: quoteNode.parentKey,
          relationFieldApiName: relateFieldApiName,
          relationFieldObjectApiName: relateObjectApiName,
          rowId: this.rowId,
          fieldType: quoteNode.type,
          field: this.relateNode,
          handler: this._handlerTrigger.bind(this)
        }
      )
    }
  },
  render (h) {
    const relateNode = this.relateNode
    /* eslint-disable */
    const Component = COMPONENTS_NAMES[relateNode.type]
    return (
      <Component
        v-model={this.value}
        props={{
          row: this.row || this.formData,
          ...relateNode,
          ...relateNode.props
        }}
        attrs={{...relateNode}}
      />
    )
  }
}
</script>
